import { render, staticRenderFns } from "./consultationRecords.vue?vue&type=template&id=619798fd&scoped=true"
import script from "./consultationRecords.vue?vue&type=script&lang=js"
export * from "./consultationRecords.vue?vue&type=script&lang=js"
import style0 from "./consultationRecords.vue?vue&type=style&index=0&id=619798fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619798fd",
  null
  
)

export default component.exports